module.exports = __webpack_public_path__ + "img/wide.b6ac5051.jpg";